export default {
  name: 'signaturepad',
  type: 'action',
  isRequired: true
}
